import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-abandoned-cart',
  templateUrl: './abandoned-cart.component.html',
  styleUrls: ['./abandoned-cart.component.scss']
})
export class AbandonedCartComponent implements OnInit {

  constructor() { }

  @Input() abandonedCart:any = [];
  @Input() currencySymbol:any;

  ngOnInit(): void {
  }

}
